import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';
import clsx from 'clsx';

type Props = BaseButtonProps & {
    isSelected?: boolean;
};
export const FloorButton = ({ children, isSelected, ...props }: Props) => {
    return (
        <BaseButton {...props} className={clsx(styles['floor-button'], isSelected && styles['floor-button--selected'])}>
            <span className={clsx(styles['floor-button__number'], 'number')}>{children}</span>
        </BaseButton>
    );
};
